import { State } from "src/state";

export const getEntityViewState = (state: State) => state.entityView;

export const getEntityViewStateEntityId = (state: State) =>
  state.entityView ? state.entityView.entityId : null;

export const getSearchCount = (state: State) => {
  return state.briefSpread.briefSpread.briefSpreadCount;
};

export const getCachedSearchOptions = (state: State) => {
  return state.searchOptions;
};



// WEBPACK FOOTER //
// ./src/entityView/selector.ts